import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";

import { useColorsContext } from "../context/colors.context";

const Color = () => {
    const { colors } = useColorsContext();
    const { setSelectedColor, nextStep } = usePaintConfiguratorContext();
    const { index } = useMapped();
    const color = colors.at(index);

    if (!color) return null;

    return (
        <Button
            className={cn(
                "tw:group tw:p-0 tw:ring-1 tw:overflow-hidden tw:ring-gray-300 tw:hover:ring-offset-2 tw:hover:scale-[1.01] tw:transition-all"
            )}
            color="transparent"
            onClick={() => {
                setSelectedColor(color);
                nextStep();
            }}
        >
            <div
                className={cn(
                    "tw:aspect-square tw:w-full tw:transition-transform tw:duration-500"
                )}
                style={{ backgroundColor: `#${color.hexValue}` }}
            ></div>
            <div
                className={cn(
                    "tw:p-3 tw:align-middle tw:bg-background tw:text-grey-dark tw:text-sm"
                )}
            >
                <p className={cn("tw:m-0!")}>{color.name}</p>
            </div>
        </Button>
    );
};

export { Color };
